// extracted by mini-css-extract-plugin
module.exports = {"whats-included":"styles_whats-included__biOEp"};